export default "Bailleurs sociaux — Collectivités | Solution Éco France";
